import { FormikProps } from 'formik'
import { Contact, ContactProfile } from '../../api/contacts/types'
import { CONTACT_PROFILE_STATUS } from '../../common/constants'

export interface FilteredContact {
    id: number
    internalAppId: number | null
    city: string | null
    contactPerson?: { firstName: string; lastName: string }
    agentFirstName: string | null
    agentLastName: string | null
}

export const getFilteredContact = (contact: Contact): FilteredContact => ({
    id: contact.id,
    internalAppId: contact.internalAppId,
    city: contact.city,
    contactPerson: contact.contactPerson
        ? { firstName: contact.contactPerson.firstName ?? '', lastName: contact.contactPerson.lastName ?? '' }
        : undefined,
    agentFirstName: contact.agent.firstName,
    agentLastName: contact.agent.lastName,
})

/**
 * Handles form submission for multiple Formik forms
 * Checks which forms have been interacted with and are dirty, then submits them in parallel
 */
export const handleMultiFormSubmit = async (e: React.FormEvent, formikInstances: FormikProps<any>[]) => {
    e.preventDefault()

    const promises: Promise<void>[] = []

    formikInstances.forEach((formik) => {
        const hasInteraction = Object.keys(formik.touched).length > 0

        if (formik.dirty || hasInteraction) {
            promises.push(formik.submitForm())
        }
    })

    await Promise.all(promises)

    formikInstances.forEach((formik) => {
        if (formik.isValid && Object.keys(formik.errors).length === 0) {
            formik.setTouched({})
        }
    })
}

const ACTIVE_PROFILE_STATUS_IDS = [CONTACT_PROFILE_STATUS.ACTIVE_OFFER, CONTACT_PROFILE_STATUS.ACTIVE_SALES, CONTACT_PROFILE_STATUS.ACTIVE_RENTAL]

export const handleActiveContactProfiles = (profiles: ContactProfile[]): ContactProfile[] => {
    const serviceIds = [...new Set(profiles.map((p) => p.contactProfileService?.id))]
    const result: ContactProfile[] = []

    serviceIds.forEach((serviceId) => {
        const match = profiles.find(
            (p) =>
                p.contactProfileService?.id === serviceId &&
                p.contactProfileStatus?.id != null &&
                ACTIVE_PROFILE_STATUS_IDS.includes(p.contactProfileStatus.id)
        )

        if (match) result.push(match)
    })

    return result
}
